import { mathTopic } from '../types/tutor-on-demand-math.types'

export const mathTopicLinks = {
  [mathTopic.ARITHMETIC]: {
    no: '/encyclopedia/tall-og-maaling/regning',
    en: '/encyclopedia/numbers-and-quantities/arithmetic',
    uk: '/encyclopedia/chysla-ta-velychyny/aryfmetyka',
  },
  [mathTopic.THE_TIMES_TABLES]: {
    no: '/drill/gangetabellen/den-lille-gangetabellen',
    en: '/drill/the-multiplication-table/the-times-tables',
    uk: '/drill/tablytsya-mnozhennya/tablytsya-mnozhennya',
  },
  [mathTopic.FRACTIONS]: {
    no: '/drill/brok',
    en: '/drill/fractions',
    uk: '/drill/droby',
  },
  [mathTopic.PARENTHESES]: {
    no: '/drill/parenteser',
    en: '/drill/parentheses',
    uk: '/drill/kruhli-duzhky',
  },
  [mathTopic.UNITS_OF_MEASUREMENT]: {
    no: '/encyclopedia/tall-og-maaling/enheter/maaleenheter/metrisk',
    en: '/encyclopedia/numbers-and-quantities/quantities/measuring',
    uk: '/encyclopedia/chysla-ta-velychyny/velychyny/odynytsi-vymiryuvannya',
  },
  [mathTopic.EXCHANGE_RATES]: {
    no: '/encyclopedia/tall-og-maaling/okonomi/penger/valuta',
    en: '/encyclopedia/numbers-and-quantities/economy/money/how-currency-exchange-works',
    uk: '/encyclopedia/chysla-ta-velychyny/ekonomika/hroshi/u-chomu-sut-obminu-valyut',
  },
  [mathTopic.PROBABILITY]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/sannsynlighet-og-kombinatorikk',
    en: '/encyclopedia/statistics-and-probability/probability-and-combinatorics',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/imovirnist-i-kombinatoryka',
  },
  [mathTopic.POWERS]: {
    no: '/drill/potenser',
    en: '/drill/powers',
    uk: '/drill/stepin-chysla',
  },
  [mathTopic.ALGEBRA]: {
    no: '/encyclopedia/algebra',
    en: '/encyclopedia/algebra',
    uk: '/encyclopedia/alhebra',
  },
  [mathTopic.FUNCTIONS]: {
    no: '/drill/funksjoner',
    en: '/drill/functions',
    uk: '/drill/funktsiyi',
  },
  [mathTopic.DIFFERENTIATION]: {
    no: '/encyclopedia/funksjoner/derivasjon-og-funksjonsdrofting/derivasjon',
    en: '/encyclopedia/functions/derivation-and-its-applications/derivation',
    uk: '/encyclopedia/funktsiyi/dyferentsiyuvannya-ta-sposoby-yoho-zastosuvannya/sposoby-zastosuvannya-pokhidnykh',
  },
  [mathTopic.INTEGRATION]: {
    no: '/encyclopedia/funksjoner/integraler',
    en: '/encyclopedia/functions/integrals',
    uk: '/encyclopedia/funktsiyi/intehraly',
  },
  [mathTopic.GEOMETRY]: {
    no: '/encyclopedia/geometri',
    en: '/encyclopedia/geometry',
    uk: '/encyclopedia/heometriya',
  },
  [mathTopic.TRIGONOMETRY]: {
    no: '/encyclopedia/geometri/trigonometri',
    en: '/encyclopedia/geometry/trigonometry',
    uk: '/encyclopedia/heometriya/tryhonometriya',
  },
  [mathTopic.VECTORS]: {
    no: '/encyclopedia/tall-og-maaling/vektorer',
    en: '/encyclopedia/numbers-and-quantities/vectors',
    uk: '/encyclopedia/chysla-ta-velychyny/vektory',
  },
  [mathTopic.SPREADSHEETS]: { no: '/excel', en: '/excel', uk: '/excel' },
  [mathTopic.GEOGEBRA]: { no: '/geogebra', en: '/geogebra', uk: '/geogebra' },
}
